import i from './splash.container';

export default i;
